const Configuration = {
  dpr: 1,
  invert_mouse: false,
};

export { Configuration };
